import { render, staticRenderFns } from "./PuzzleListTable.vue?vue&type=template&id=1c50d87b&scoped=true&lang=html"
import script from "./PuzzleListTable.vue?vue&type=script&lang=js"
export * from "./PuzzleListTable.vue?vue&type=script&lang=js"
import style0 from "./PuzzleListTable.vue?vue&type=style&index=0&id=1c50d87b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c50d87b",
  null
  
)

export default component.exports